import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, ReplaySubject, of, share, timer,  } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { ConfigService } from '../../config';
import { AppState, AuthState } from '../../state';
import { AuthServiceBase } from './auth-service-base.model';

/** An offset to renew the headless token before it expires. */
const HEADLESS_TOKEN_CACHE_TIMEOUT = 5 * 60 * 1000; // 5 mins in miliseconds;
@Injectable({
  providedIn: 'root',
})
export class HeadlessAuthService implements AuthServiceBase {
  private store = inject(Store);
  private oidcSecurityService = inject(OidcSecurityService);
  private configService = inject(ConfigService);
  private http = inject(HttpClient);

  private _isAuthenticated: boolean;
  private _tokenSource$: Observable<string>;

  constructor() {
    this.configService.appConfigInit$
      .pipe(
        filter((config) => !!config),
        distinctUntilChanged(),
        switchMap(() => this.store.select(AuthState.isAuthenticated)),
      )
      .subscribe((isAuth = false) => {
        if (this._isAuthenticated !== isAuth) {
          this._isAuthenticated = isAuth;
          this._setupAccessTokenSource();
        }
      });
  }

  checkAuth(): Observable<boolean> {
    return of(!!this.store.selectSnapshot(AppState.headlessConfig).userId);
  }

  signIn(): void {}

  signOut(): Observable<any> {
    return of(null);
  }

  resetAuthData(): void {}

  getAccessToken(): Observable<string> {
    return this._tokenSource$;
  }
  getCurrentUserId(): Observable<string> {
    return of(this.store.selectSnapshot(AppState.headlessConfig).userId);
  }
  isUserSessionExpired(): boolean {
    return false;
  }

  private _setupAccessTokenSource(): void {
    this._tokenSource$ = this._getClientToken().pipe(
      share({
        connector: () => new ReplaySubject(1),
        resetOnComplete: () => timer(HEADLESS_TOKEN_CACHE_TIMEOUT),
      }),
    );
  }

  private _getClientToken(): Observable<string> {
    const { SYSTEM_ClIENT_ID, SYSTEM_ClIENT_SECRET } =
      this.configService.configuration;

    const params = new HttpParams()
      .set('client_id', SYSTEM_ClIENT_ID)
      .set('client_secret', SYSTEM_ClIENT_SECRET)
      .set('grant_type', 'client_credentials');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.oidcSecurityService.getConfiguration().pipe(
      switchMap(({ authWellknownEndpoints }) =>
        this.http.post(authWellknownEndpoints.tokenEndpoint, params, {
          headers,
        }),
      ),
      map((res: { access_token: string }) => res.access_token),
    );
  }
}
